<template>
  <!-- calculator section -->
	<div class="calc-outer-container">
		<div class="container">
			<div class="row">
				<div class="col-lg-10 offset-lg-1">
					<div class="row align-items-center">
						<div class="col-sm-5">
							<div class="calculator-image-box">
								<img loading="lazy" src="img/goals-calc-image.webp" width="229" height="322" alt="Wealth creation calculator to know how much wealth you need to live happily and comfortably">
							</div>
						</div>
						<div class="col-sm-7">
							<div class="goals-calc-container">
								<div class="steps-heading">
									<h2 class="hf_heading02">Tell us what you require</h2>
								</div>
								<!-- calculator section -->
								<div class="goals-calculator-box captcha-div">
								  <div class="calculator">
								    <form action="show-wealth-result" method="post" id="showWealthResult">
								    	<input type="hidden" v-model="_token" name="_token">
								      <div class="form-group dynamic-input">
								        <label>I want to invest<span class="inr-symbol hf_dark">&#8377;</span></label>
								        <input type="text" id="lumpamt" name="lumpamt" v-model="lumpamt" class="restDot numbersonly " :class="lumpamtMClass" @keyup="resetCalculation(); resetSipMClass();" placeholder="1,00,000" min="0" maxlength="14" required>
								        <span>one-time and</span>
								      </div>
								      <div class="form-group dynamic-input">
								        <label for="name"><span>&#8377;</span></label>
								        <input type="text" id="sipamt" name="sipamt" v-model="sipamt" class="restDot numbersonly" :class="sipamtMClass" @keyup="resetCalculation(); resetLumpMClass();" placeholder="10,000" min="0" maxlength="14" required>
								        <span>monthly for a period of
								        	<input type="number" id="year" name="yearReqd" v-model="yearReqd" class="restDot numbersonly width-dynamic" :class="yearReqdMClass" @keyup="resetCalculation()" placeholder="20" min="0" maxlength="2" @input="updateYearVal()" required>
								        	years.
								        </span>
								      </div>
								      <VueRecaptcha 
                        sitekey="6Ldr460jAAAAAO6wyw1mVTSg_2T2Zp9WTkO9SL_9" 
                        ref="recaptcha"
                        size="invisible"
                        :load-recaptcha-script="true" 
                        @verify="recaptchaVerified" 
                        @expired="resetCaptcha">
                      </VueRecaptcha>
								      <div class="notification-message">
									      <p v-show="showError" class="errorMessage inflation-text hf_bodytext02">
									      	<span class="errorCircle"><span class="errorSymbol">&#33;</span></span>
				                  {{ showErrorText }}
				                </p>
				              </div>
								      <div class="button-container">
								        <a type="button" class="btn-primaryNoIcon lg-primarynoIcon" @click.stop="showResult()">Know more</a>
								      </div>
								    </form>
								  </div>
								</div>
								<!-- end calculator section -->
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!-- end calculator section -->
</template>

<script>
import { VueRecaptcha } from 'vue-recaptcha';
export default {
	components: {
    VueRecaptcha
  },
  created() {},
  data() {
    return {
    	_token : this.$token,
    	validationflag: 0,
    	fvResultHtml: '',
    	accmpYear: '',
    	lumpamtMClass: '',
    	sipamtMClass: '',
    	yearReqdMClass: '',
    	mandatoryClassName: 'redunderline',
    	showErrorText: '',
    	showError: false,
    	recaptchaToken:'',
    	lumpamt:'',
    	sipamt:'',
    	yearReqd:'',
    };
  },
  props: { },
  watch: {
	lumpamt(){
		var res =  this.formatAmount(this.lumpamt)
		this.lumpamt = res;
    },
	sipamt(){
		var res =  this.formatAmount(this.sipamt)
		this.sipamt = res;
    },
  },
  mounted(){
  },
  methods: {
    updateYearVal: function(){
      var element = event.target;
      var maxlength = element.getAttribute('maxlength');
      if(this.yearReqd.toString().length > maxlength){
        let number = this.yearReqd;
        this.yearReqd = number.toString().substring(0, number.toString().length - 1);
      }
    },
  	resetCaptcha() {
    //   console.log("resetCaptcha");
      this.$refs.recaptcha.reset();
      this.recaptchaToken = "";
    },
    recaptchaVerified(token) {
    //   console.log("recaptchaVerified");
      if (token ) this.recaptchaToken = token;
  		// console.log("recaptchaToken="+ this.recaptchaToken);
      document.getElementById("showWealthResult").submit();
    },
  	showResult(){
  		// console.log("Click event triggered");

  		//Check for validation and collect data for calculations
  		//======================================================
  		let sipamt = this.sipamt;
  		sipamt = String(sipamt).replace(new RegExp(',', 'g'), '');
  		let lumpamt = this.lumpamt;
  		lumpamt = String(lumpamt).replace(new RegExp(',', 'g'), '');
  		let yearReqd = this.yearReqd;

  		if((sipamt == "" || sipamt == undefined) && (lumpamt == "" || lumpamt == undefined) || yearReqd == "" || yearReqd == undefined){
  			this.validationflag = 0;
  			this.showErrorText = "Please enter mandatory data first";
  			this.showError = true;

  			// Check for mandatory fields
  			//==============================
  			if(sipamt == "" || sipamt == undefined){
  				this.sipamtMClass = this.mandatoryClassName;
  			}else{
  				this.sipamtMClass = "";
  			}

  			if(lumpamt == "" || lumpamt == undefined){
  				this.lumpamtMClass = this.mandatoryClassName;
  			}else{
  				this.lumpamtMClass = "";
  			}

  			if(yearReqd == "" || yearReqd == undefined){
  				this.yearReqdMClass = this.mandatoryClassName;
  			}else{
  				this.yearReqdMClass = "";
  			}

  		}else{
  			//remove all redunderline class for mandatory
        //============================================
        this.sipamtMClass = "";
        this.lumpamtMClass = "";
        this.yearReqdMClass = "";
        
  			//Check all the basic validations eg.age, amt
				//=============================================
				axios.post('/chkWealthGoalValidations',{sipamt: sipamt, lumpamt: lumpamt, yearReqd: yearReqd, calcReq: 0,  _token: this.$token})
        .then((response)=>{
        	// console.log(response);
        	let resData = response.data;
        	if(resData.status == true){
						this.showErrorText = "";
			    	this.showError = false;
        		// Show result on next page
					  //==================================================
						// this.$nextTick is added because above form is submitted before values changed in form
						//--------------------------------------------------------
				  	// this.$nextTick(() => {
					    
					    // Trigger clevertap event
				    	//===================================================
								// clevertap.event.push("Wealth Calculator", {
								//   "page name": window.location.pathname,
								//   "Lumpsum": lumpamt,
								//   "Monthly": sipamt,
								//   "Year": yearReqd,
								// });

								//execute captcha call here
								//=========================================
								this.$refs.recaptcha.execute();
				   			
			    	// 	});
        	}else{
  					if(resData.error == undefined){
        			this.showErrorText = "Page session expired, Please refresh the page";
  						this.showError = true;
        		}else{
        			this.showErrorText = resData.error;
  						this.showError = true;
        		}

			  		//Reset captcha called
			  		//=====================================
			  		this.resetCaptcha();
        	}
        }).catch(response => {
		        console.log(response.data);
		    })

  		}
  	},
  	resetCalculation(){
      // On keyup of field show button for calculation and hide result 
			//================================================================
			this.showErrorText = "";
    	this.showError = false;
    },
    resetSipMClass(){
    	this.sipamtMClass = "";
    },
    resetLumpMClass(){
    	this.lumpamtMClass = "";
    }
  },
};
</script>

<style lang="scss" scoped></style>
